

<h1 class="page-header">Careers at NordNative</h1>

<style>
    .hero-section {
        background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://via.placeholder.com/1500x500') center/cover no-repeat;
        color: #fff;
        text-align: center;
        padding: 100px 20px;
    }
</style>


<!-- About Us Section -->
<section class="py-5">
    <div class="container text-center">
        <h2>Why Work With Us?</h2>
        <p class="mb-4">We are a dynamic SaaS company building sales and marketing automation software, and we value innovation, collaboration, and growth.
            Join a team where your ideas make a difference.</p>
        <div class="row g-4">
            <div class="col-md-4">
                <div class="card p-4 text-center">
                    <h5 class="card-title">Innovation</h5>
                    <p class="card-text">Work with cutting-edge technology and contribute to groundbreaking projects.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card p-4 text-center">
                    <h5 class="card-title">Growth</h5>
                    <p class="card-text">Unlock your potential with opportunities for professional development.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card p-4 text-center">
                    <h5 class="card-title">Culture</h5>
                    <p class="card-text">Be part of a collaborative and inclusive environment where ideas thrive.</p>
                </div>
            </div>
        </div>
    </div>
</section>

<!--
<section class="hero-section">
    <div class="container">
        <h1 class="display-4">Join Our Team</h1>
        <p class="lead">Shape the future of technology with us. Explore exciting career opportunities!</p>
        <a href="#open-positions" class="btn btn-primary btn-lg">View Open Positions</a>
    </div>
</section>
-->

<section class="py-5">
    <div class="container text-center">
        <p>Follow us on LinkedIn to stay updated with our latest news and job postings!</p>
        <div class="col-xs-12" style="height:50px;"></div>
        <a href="{{SOCIAL_LINK_LINKEDIN}}" target="_blank">
            <img src="https://cdn-icons-png.flaticon.com/512/174/174857.png" alt="LinkedIn Logo"
                style="width: 50px; height: auto;">
        </a>
    </div>
</section>

<app-jobs-gallery></app-jobs-gallery>
